export default __webpack_public_path__ + "static/media/boarding.b5a7d4e3.svg";